// // src/_helper/license/LicenseContext.jsx
// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { jwtVerify } from 'jose';
// import localforage from 'localforage';

// const LicenseContext = createContext();

// // Configure localforage to survive cache clear
// localforage.config({
//     name: 'ClinicDotsPharmacy',
//     storeName: 'license_store',
//     description: 'Persistent license storage'
// });

// const TOKEN_KEY = 'license_token';
// const LAST_VALID_TIME_KEY = 'license_last_valid_time';

// const PUBLIC_KEY_PEM = `-----BEGIN PUBLIC KEY-----
// MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA6GACe0S3bwEoIcfLU1bu
// KkJpBUMITjAcKtyHMCuzKoke3/6865P1HpYeOdFMi57ythD3aVdoA3MhrWXoFBvh
// 9e31WXeI52zLT2H5myciq4Byne0p+M2JQr7hn8WeOF820is30z4p45pPKQC/yEQ0
// DEKC0YwnYVzPYCo0As6xdGiIhjh14dC7yWN1KWYxhWBCEJ5uuP4taamV2XCHbbxX
// XGOihNC2ISkxRdUqelc0dHoidt2r6+I2orIEnblvwKfBb2QUtL5lZsWm5WNamirR
// jOOniVLJ+6a1kG5tIo7rSY/hCgB2ZfFx9gWLm9WAjt+06SvtXCb97xXf1LfkmAxj
// DwIDAQAB
// -----END PUBLIC KEY-----`;

// export const LicenseProvider = ({ children }) => {
//     const [licenseStatus, setLicenseStatus] = useState('checking');
//     const [licenseData, setLicenseData] = useState(null);

//     const getPublicKey = async () => {
//         const pem = PUBLIC_KEY_PEM
//             .replace(/-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\n/g, '')
//             .replace(/\s+/g, '');
//         const binaryDer = Uint8Array.from(atob(pem), c => c.charCodeAt(0));
//         return await crypto.subtle.importKey(
//             'spki',
//             binaryDer.buffer,
//             { name: 'RSASSA-PKCS1-v1_5', hash: 'SHA-256' },
//             true,
//             ['verify']
//         );
//     };

//     const validateToken = async (token) => {
//         try {
//             const key = await getPublicKey();
//             const { payload } = await jwtVerify(token.trim(), key, { algorithms: ['RS256'] });
//             // console.log(payload);

//             const now = Date.now();

//             // Get expiry time
//             let expiryTime;
//             if (payload.expiresAt) {
//                 expiryTime = typeof payload.expiresAt === 'string'
//                     ? parseInt(payload.expiresAt)
//                     : payload.expiresAt;
//             } else if (payload.exp) {
//                 expiryTime = payload.exp * 1000;
//             }

//             if (!expiryTime) {
//                 setLicenseStatus('invalid');
//                 return;
//             }

//             // ANTI-CLOCK-ROLLBACK
//             const lastValidTime = await localforage.getItem(LAST_VALID_TIME_KEY);
//             if (lastValidTime && now < parseInt(lastValidTime)) {
//                 setLicenseStatus('time-tampered');
//                 setLicenseData(payload);
//                 return;
//             }

//             // Check expiry
//             if (expiryTime < now) {
//                 setLicenseStatus('expired');
//                 setLicenseData(payload);
//                 return;
//             }

//             // VALID → update last valid time
//             await localforage.setItem(LAST_VALID_TIME_KEY, now.toString());
//             setLicenseData(payload);
//             setLicenseStatus('valid');

//         } catch (err) {
//             console.error('License verification failed:', err.message);
//             setLicenseStatus('invalid');
//         }
//     };

//     useEffect(() => {
//         const check = async () => {
//             try {
//                 const token = await localforage.getItem(TOKEN_KEY);
//                 if (!token) {
//                     setLicenseStatus('none');
//                     return;
//                 }
//                 await validateToken(token);
//             } catch (err) {
//                 setLicenseStatus('invalid');
//             }
//         };

//         check();
//         const interval = setInterval(check, 5000);
//         const onFocus = () => check();
//         window.addEventListener('focus', onFocus);

//         return () => {
//             clearInterval(interval);
//             window.removeEventListener('focus', onFocus);
//         };
//     }, []);

//     // Save license (used in Activation page)
//     const saveLicenseToken = async (token) => {
//         await localforage.setItem(TOKEN_KEY, token.trim());
//     };

//     // Clear license (logout or manual)
//     const clearLicense = async () => {
//         await localforage.removeItem(TOKEN_KEY);
//         await localforage.removeItem(LAST_VALID_TIME_KEY);
//         setLicenseStatus('none');
//         setLicenseData(null);
//     };

//     const decodeTokenOnly = async () => {
//         const token = await localforage.getItem(TOKEN_KEY);
//         if (!token) return null;
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64)
//                 .split('')
//                 .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
//                 .join('')
//         );

//         return JSON.parse(jsonPayload);
//     };

//     return (
//         <LicenseContext.Provider value={{
//             licenseStatus,
//             licenseData,
//             isValid: licenseStatus === 'valid',
//             isChecking: licenseStatus === 'checking',
//             needsActivation: ['none', 'invalid', 'expired', 'time-tampered'].includes(licenseStatus),
//             saveLicenseToken,
//             clearLicense,
//             decodeTokenOnly
//         }}>
//             {children}
//         </LicenseContext.Provider>
//     );
// };

// export const useLicense = () => useContext(LicenseContext);


// src/_helper/license/LicenseContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtVerify } from 'jose';
import localforage from 'localforage';
import { useNavigate } from 'react-router';
import { useLab } from './PharmacyProvider';

const LicenseContext = createContext();

// Configure localforage to survive cache clear
localforage.config({
    name: 'ClinicDotsPharmacy',
    storeName: 'license_store',
    description: 'Persistent license storage'
});

const TOKEN_KEY = 'license_token';
const LAST_VALID_TIME_KEY = 'license_last_valid_time';

const PUBLIC_KEY_PEM = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA6GACe0S3bwEoIcfLU1bu
KkJpBUMITjAcKtyHMCuzKoke3/6865P1HpYeOdFMi57ythD3aVdoA3MhrWXoFBvh
9e31WXeI52zLT2H5myciq4Byne0p+M2JQr7hn8WeOF820is30z4p45pPKQC/yEQ0
DEKC0YwnYVzPYCo0As6xdGiIhjh14dC7yWN1KWYxhWBCEJ5uuP4taamV2XCHbbxX
XGOihNC2ISkxRdUqelc0dHoidt2r6+I2orIEnblvwKfBb2QUtL5lZsWm5WNamirR
jOOniVLJ+6a1kG5tIo7rSY/hCgB2ZfFx9gWLm9WAjt+06SvtXCb97xXf1LfkmAxj
DwIDAQAB
-----END PUBLIC KEY-----`;


export const LicenseProvider = ({ children }) => {
    const history = useNavigate();
    const [licenseStatus, setLicenseStatus] = useState('checking');
    const [licenseData, setLicenseData] = useState(null);
    const [isChecking, setIsChecking] = useState(true);
    const [skipValidation, setSkipValidation] = useState(false);
    const { currentLab } = useLab();

    const getPublicKey = async () => {
        const pem = PUBLIC_KEY_PEM
            .replace(/-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\n/g, '')
            .replace(/\s+/g, '');
        const binaryDer = Uint8Array.from(atob(pem), c => c.charCodeAt(0));
        return await crypto.subtle.importKey(
            'spki',
            binaryDer.buffer,
            { name: 'RSASSA-PKCS1-v1_5', hash: 'SHA-256' },
            true,
            ['verify']
        );
    };

    const validateToken = async (token) => {
        try {
            const key = await getPublicKey();
            const { payload } = await jwtVerify(token.trim(), key, { algorithms: ['RS256'] });

            const now = Date.now();

            // Get expiry time
            let expiryTime;
            if (payload.expiresAt) {
                expiryTime = typeof payload.expiresAt === 'string'
                    ? parseInt(payload.expiresAt)
                    : payload.expiresAt;
            } else if (payload.exp) {
                expiryTime = payload.exp * 1000;
            }

            if (!expiryTime) {
                setLicenseStatus('invalid');
                setIsChecking(false);
                return;
            }

            let activationTime;
            if (payload.activationDate) {
                activationTime = new Date(payload.activationDate).getTime();
            }

            // ENHANCED ANTI-TAMPERING with activationDate reference
            const lastValidTime = await localforage.getItem(LAST_VALID_TIME_KEY);
            const storedInstallTime = await localforage.getItem('license_install_time');

            if (!storedInstallTime) {
                if (activationTime) {
                    await localforage.setItem('license_install_time', activationTime.toString());
                } else {
                    await localforage.setItem('license_install_time', now.toString());
                }
            } else {
                const installTimestamp = parseInt(storedInstallTime);

                // Check if system time went backwards (tampered)
                if (activationTime && now < activationTime - 86400000) {
                    console.error('System time set before license activation date!', {
                        systemTime: new Date(now).toISOString(),
                        activationDate: new Date(activationTime).toISOString()
                    });
                    setLicenseStatus('time-tampered');
                    setLicenseData(payload);
                    setIsChecking(false);
                    return;
                }

                if (now < installTimestamp - 86400000) {
                    setLicenseStatus('time-tampered');
                    setLicenseData(payload);
                    setIsChecking(false);
                    return;
                }
            }

            if (lastValidTime) {
                const lastValid = parseInt(lastValidTime);
                // Check if time went backwards by more than 5 minutes
                if (now < lastValid - 300000) {
                    console.error('System time tampered detected!', {
                        lastValidTime: new Date(lastValid).toISOString(),
                        currentTime: new Date(now).toISOString(),
                        difference: lastValid - now
                    });
                    setLicenseStatus('time-tampered');
                    setLicenseData(payload);
                    setIsChecking(false);
                    return;
                }
            }

            // Check expiry
            if (expiryTime < now) {
                setLicenseStatus('expired');
                // clearLicense()
                setLicenseData(payload);
                setIsChecking(false);
                return;
            }

            // VALID → update last valid time
            await localforage.setItem(LAST_VALID_TIME_KEY, now.toString());
            setLicenseData(payload);
            setLicenseStatus('valid');
            setIsChecking(false);

        } catch (err) {
            console.error('License verification failed:', err.message);
            setLicenseStatus('invalid');
            setIsChecking(false);
        }
    };

    const decodeTokenOnly = async () => {
        const token = await localforage.getItem(TOKEN_KEY);
        if (!token) return null;
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );

        return JSON.parse(jsonPayload);
    };

    const doesLicenseBelongToUser = (payload, userId) => {
        if (!payload || !userId) return false;

        // Case 1: users array
        if (Array.isArray(payload.users)) {
            if (payload.users.some(u => u.id === userId)) return true;
        }

        // Case 2: subUserIds array
        if (Array.isArray(payload.subUserIds)) {
            if (payload.subUserIds.includes(userId)) return true;
        }

        return false;
    };

    // Perform validation check
    const performValidation = async () => {
        if (!currentLab || !currentLab._id || skipValidation) {
            return;
        }

        try {
            const decodedPayload = await decodeTokenOnly();

            if (!decodedPayload) {
                setLicenseStatus('none');
                setIsChecking(false);
                return;
            }

            // Check if license belongs to current user
            const userBelongs = doesLicenseBelongToUser(decodedPayload, currentLab._id);

            if (!userBelongs) {
                setLicenseStatus('none');
                setIsChecking(false);
                return;
            }

            // NOW validate the token
            const token = await localforage.getItem(TOKEN_KEY);
            if (!token) {
                setLicenseStatus('none');
                setIsChecking(false);
                return;
            }

            await validateToken(token);
        } catch (err) {
            console.error('License check error:', err);
            setLicenseStatus('invalid');
            setIsChecking(false);
        }
    };

    // Initial validation when currentLab changes
    useEffect(() => {
        if (!currentLab || !currentLab._id) {
            setIsChecking(false);
            setLicenseStatus('none');
            return;
        }

        if (skipValidation) {
            return;
        }

        performValidation();
    }, [currentLab?._id, skipValidation]);

    // Continuous validation every 5 seconds - THIS IS KEY FOR DETECTING TIME TAMPERING
    useEffect(() => {
        if (!currentLab || !currentLab._id || skipValidation) {
            return;
        }

        // Validate immediately
        performValidation();

        // Then validate every 5 seconds
        const interval = setInterval(() => {
            performValidation();
        }, 5000);

        // Also validate on window focus
        const onFocus = () => performValidation();
        window.addEventListener('focus', onFocus);

        return () => {
            clearInterval(interval);
            window.removeEventListener('focus', onFocus);
        };
    }, [currentLab?._id, skipValidation]);

    const saveLicenseToken = async (token) => {
        await localforage.setItem(TOKEN_KEY, token.trim());

        // Immediately validate after saving
        await validateToken(token.trim());
    };

    const clearLicense = async () => {
        await localforage.removeItem(TOKEN_KEY);
        await localforage.removeItem(LAST_VALID_TIME_KEY);
        await localforage.removeItem('license_install_time');
        setLicenseStatus('none');
        setLicenseData(null);
        setIsChecking(false);
    };

    const decodeJWT = (token) => {
        try {
            const base64Url = token.split(".")[1];
            const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split("")
                    .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                    .join("")
            );

            return JSON.parse(jsonPayload);
        } catch (error) {
            console.error("Invalid JWT", error);
            return null;
        }
    };


    return (
        <LicenseContext.Provider value={{
            licenseStatus,
            licenseData,
            isValid: licenseStatus === 'valid',
            isChecking,
            needsActivation: ['none', 'invalid', 'expired', 'time-tampered'].includes(licenseStatus),
            saveLicenseToken,
            clearLicense,
            decodeTokenOnly,
            doesLicenseBelongToUser,
            setSkipValidation,
            decodeJWT
        }}>
            {children}
        </LicenseContext.Provider>
    );
};

export const useLicense = () => useContext(LicenseContext);



// export const LicenseProvider = ({ children }) => {
//     const history = useNavigate();
//     const [licenseStatus, setLicenseStatus] = useState('checking');
//     const [licenseData, setLicenseData] = useState(null);
//     const [isChecking, setIsChecking] = useState(true);
//     // const user = localStorage.getItem('currentcurrentLab')
//     const { currentLab } = useLab();
//     const getPublicKey = async () => {
//         const pem = PUBLIC_KEY_PEM
//             .replace(/-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\n/g, '')
//             .replace(/\s+/g, '');
//         const binaryDer = Uint8Array.from(atob(pem), c => c.charCodeAt(0));
//         return await crypto.subtle.importKey(
//             'spki',
//             binaryDer.buffer,
//             { name: 'RSASSA-PKCS1-v1_5', hash: 'SHA-256' },
//             true,
//             ['verify']
//         );
//     };

//     const validateToken = async (token) => {
//         try {
//             const key = await getPublicKey();
//             const { payload } = await jwtVerify(token.trim(), key, { algorithms: ['RS256'] });

//             const now = Date.now();

//             // Get expiry time
//             let expiryTime;
//             if (payload.expiresAt) {
//                 expiryTime = typeof payload.expiresAt === 'string'
//                     ? parseInt(payload.expiresAt)
//                     : payload.expiresAt;
//             } else if (payload.exp) {
//                 expiryTime = payload.exp * 1000;
//             }

//             if (!expiryTime) {
//                 setLicenseStatus('invalid');
//                 return;
//             }

//             // CRITICAL FIX: Use activationDate from JWT as reference point
//             let activationTime;
//             if (payload.activationDate) {
//                 // Convert activationDate to timestamp
//                 activationTime = new Date(payload.activationDate).getTime();
//             }

//             // ENHANCED ANTI-TAMPERING with activationDate reference
//             const lastValidTime = await localforage.getItem(LAST_VALID_TIME_KEY);
//             const storedInstallTime = await localforage.getItem('license_install_time');

//             // First time activation OR after storage clear
//             if (!storedInstallTime) {
//                 // Store activation time from JWT
//                 if (activationTime) {
//                     await localforage.setItem('license_install_time', activationTime.toString());
//                 } else {
//                     // Fallback to current time if no activationDate in payload
//                     await localforage.setItem('license_install_time', now.toString());
//                 }
//             } else {
//                 const installTimestamp = parseInt(storedInstallTime);

//                 // CRITICAL CHECK: Current time should NEVER be before activation date
//                 if (activationTime && now < activationTime - 86400000) { // 24-hour buffer
//                     console.error('System time set before license activation date!', {
//                         systemTime: new Date(now).toISOString(),
//                         activationDate: new Date(activationTime).toISOString()
//                     });
//                     setLicenseStatus('time-tampered');
//                     setLicenseData(payload);
//                     return;
//                 }

//                 // Also check against stored installation time
//                 if (now < installTimestamp - 86400000) { // 24-hour buffer
//                     setLicenseStatus('time-tampered');
//                     setLicenseData(payload);
//                     return;
//                 }
//             }

//             // Check for clock rollback using last valid time
//             if (lastValidTime) {
//                 const lastValid = parseInt(lastValidTime);
//                 // If current time is significantly earlier than last valid time
//                 if (now < lastValid - 300000) { // 5-minute tolerance
//                     setLicenseStatus('time-tampered');
//                     setLicenseData(payload);
//                     return;
//                 }
//             }

//             // Check expiry
//             if (expiryTime < now) {
//                 setLicenseStatus('expired');
//                 setLicenseData(payload);
//                 return;
//             }

//             // VALID → update last valid time
//             await localforage.setItem(LAST_VALID_TIME_KEY, now.toString());
//             setLicenseData(payload);
//             setLicenseStatus('valid');

//         } catch (err) {
//             console.error('License verification failed:', err.message);
//             setLicenseStatus('invalid');
//         }
//     };

//     useEffect(() => {
//         if (!currentLab) {
//             history(`${process.env.PUBLIC_URL}/login`, { replace: true });
//             setIsChecking(false);
//             return;
//         }

//         const check = async () => {
//             try {
//                 const decodedPayload = await decodeTokenOnly();
//                 const userBelongs = doesLicenseBelongToUser(decodedPayload, currentLab._id);

//                 if (userBelongs) {
//                     const token = await localforage.getItem(TOKEN_KEY);
//                     if (!token) {
//                         setLicenseStatus('none');
//                         setIsChecking(false);
//                         return;
//                     }
//                     await validateToken(token);
//                     setIsChecking(false);
//                 } else {
//                     setLicenseStatus('none');
//                     setIsChecking(false);
//                     return;
//                 }
//             } catch (err) {
//                 setLicenseStatus('invalid');
//                 setIsChecking(false);
//             }
//         };

//         check();
//         const interval = setInterval(check, 5000);
//         const onFocus = () => check();
//         window.addEventListener('focus', onFocus);

//         return () => {
//             clearInterval(interval);
//             window.removeEventListener('focus', onFocus);
//         };
//     }, [currentLab])

//     // Save license (used in Activation page)
//     const saveLicenseToken = async (token) => {
//         await localforage.setItem(TOKEN_KEY, token.trim());
//     };

//     // Clear license (logout or manual)
//     const clearLicense = async () => {
//         await localforage.removeItem(TOKEN_KEY);
//         await localforage.removeItem(LAST_VALID_TIME_KEY);
//         await localforage.removeItem('license_install_time');
//         await localforage.removeItem('license_signature');
//         await localforage.removeItem('license_activation_time');
//         setLicenseStatus('none');
//         setLicenseData(null);
//     };

//     const decodeTokenOnly = async () => {
//         const token = await localforage.getItem(TOKEN_KEY);
//         if (!token) return null;
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64)
//                 .split('')
//                 .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
//                 .join('')
//         );

//         return JSON.parse(jsonPayload);
//     };

//     const doesLicenseBelongToUser = (payload, userId) => {
//         if (!payload || !userId) return false;

//         // Case 1: users array
//         if (Array.isArray(payload.users)) {
//             if (payload.users.some(u => u.id === userId)) return true;
//         }

//         // Case 2: subUserIds array
//         if (Array.isArray(payload.subUserIds)) {
//             if (payload.subUserIds.includes(userId)) return true;
//         }

//         return false;
//     };

//     return (
//         <LicenseContext.Provider value={{
//             licenseStatus,
//             licenseData,
//             isValid: licenseStatus === 'valid',
//             isChecking,
//             needsActivation: ['none', 'invalid', 'expired', 'time-tampered'].includes(licenseStatus),
//             saveLicenseToken,
//             clearLicense,
//             decodeTokenOnly,
//             doesLicenseBelongToUser
//         }}>
//             {children}
//         </LicenseContext.Provider>
//     );
// };

// export const useLicense = () => useContext(LicenseContext);